<template>
  <app-page-subsection :title="$t('teacher.page.description_title')">
    <p class="mb-1 text-xl font-semibold">
      {{ teacher.full_name }}
    </p>
    <p class="mb-3 text-lg text-subtle">
      {{ teacher.job }}
      <teacher-companies-logos :companies="teacher.companies" :height="24" />
    </p>

    <app-text-markdown
      class="prose max-w-[850px] text-subtle"
      data-cy-teacher-description
      lazy
      :value="teacher.description"
    />
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

defineProps<{
  teacher: TeacherPageView;
}>();
</script>
